import { render, staticRenderFns } from "./VettingRecipeSelector.vue?vue&type=template&id=afbfaea0"
import script from "./VettingRecipeSelector.vue?vue&type=script&lang=js"
export * from "./VettingRecipeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports